export const TEST_EMAIL_MODAL_CONSTANTS = {
  TITLE: 'Send Test Email',
  TABS: {
    SETUP: 'Setup',
    PREVIEW: 'Preview',
    VARIABLES: 'Variables',
  },
  FORM_LABELS: {
    TEST_EMAIL_ADDRESS: 'Test Email Address',
    TEST_DATA: 'Test Data (JSON)',
  },
  FORM_PLACEHOLDER: {
    EMAIL: 'test@example.com',
    TEST_DATA: '{"user_name": "John Doe", "order_id": "12345"}',
  },
  BUTTONS: {
    LOAD_DEFAULT: 'Load Default',
    RESET: 'Reset',
    CANCEL: 'Cancel',
    PREVIEW: 'Preview',
    SEND_TEST_EMAIL: 'Send Test Email',
  },
  VALIDATION_MESSAGES: {
    INVALID_JSON: 'Invalid JSON format',
    EMPTY_EMAIL: 'Please enter a test email address',
    INVALID_EMAIL_JSON: 'Please provide valid JSON test data',
  },
  PREVIEW_TABS: {
    HTML_PREVIEW: 'HTML Preview',
    HTML_SOURCE: 'HTML Source',
    PLAIN_TEXT: 'Plain Text',
  },
  HELP_TEXTS: {
    TEST_DATA_HELP:
      'Provide test data for template variables in JSON format. Click "Load Default" to get sample data for this template type.',
    VARIABLES_INFO:
      'These are the variables available for this template type. Make sure your test data includes values for the variables you want to test.',
    NO_VARIABLES: 'No variables defined for this template.',
    INVALID_JSON_VARIABLES: 'Invalid JSON - cannot display variables',
    NO_PLAIN_TEXT: 'No plain text content provided',
    AVAILABLE_VARIABLES: 'Available Variables:',
    CURRENT_TEST_DATA: 'Current Test Data Variables:',
    EMAIL_SUBJECT: 'Email Subject:',
  },
  BUTTON_LOADING_TEXT: 'Sending...',
  MODAL_SIZE: '6xl',
  MODAL_SCROLL_BEHAVIOR: 'inside' as const,
  JSON_ERROR_STATUS: 'error' as const,
  INFO_ALERT_STATUS: 'info' as const,
} as const;
